// Erst drucken, wenn die Bilder da sind (Befund 29.10.2026).
//
// Der Lieferschein druckte von selbst nach 400 ms. Cover kommen aber vom
// Shopify-CDN und der QR-Code vom eigenen Server — war ein Bild bis
// dahin nicht geladen, fehlte es auf dem Papier („das Cover von … ist
// nicht drauf", und zwar nur manchmal, je nach Netz).
//
// Gewartet wird auf jedes <img> unter `wurzel`, bis es geladen ODER
// gescheitert ist — ein kaputtes Cover darf den Druck nicht aufhalten.
// Spätestens nach `hoechstensMs` wird trotzdem gedruckt.

export async function bilderGeladen(wurzel: ParentNode | null, hoechstensMs = 5000): Promise<void> {
  if (!wurzel) return;
  const bilder = Array.from(wurzel.querySelectorAll('img'));
  const offen = bilder.filter((b) => !b.complete);
  if (offen.length === 0) return;
  const alle = Promise.all(
    offen.map(
      (b) =>
        new Promise<void>((fertig) => {
          b.addEventListener('load', () => fertig(), { once: true });
          b.addEventListener('error', () => fertig(), { once: true });
        })
    )
  );
  await Promise.race([alle, new Promise<void>((r) => setTimeout(r, hoechstensMs))]);
}

/** Kurz warten (Layout), dann auf die Bilder, dann drucken. */
export function druckenWennBereit(wurzelSelektor: string, vorlaufMs: number): () => void {
  let abgebrochen = false;
  const t = setTimeout(() => {
    void bilderGeladen(document.querySelector(wurzelSelektor)).then(() => {
      if (!abgebrochen) window.print();
    });
  }, vorlaufMs);
  return () => {
    abgebrochen = true;
    clearTimeout(t);
  };
}
